import { LayoutRoute, Route } from "@soft-db/typed-router";

const errorsRoutes = new LayoutRoute({
	name: "errors",
	path: "",
	children: [
		new Route({
			path: "internal-error",
			component: () => import("@/pages/__503__.vue"),
		}),
		new Route({
			path: "/:pathMatch(.*)*:path+",
			name: "404",
			component: () => import("@/pages/__404__.vue"),
		}),
	],
});

export default errorsRoutes;
